import { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
  groupActivitiesByDate,
  groupActivitiesForTimeline,
} from "@miplatform/utils";
import { ActivityTimeline, EmptyMessageView } from "@mibuildweb/components";
import { Box } from "@mui/material";
import { IssueList } from "../../IssueList/IssueList";
import { Closingout } from "../Issues/Closingout/Closingout";
import { useAttemptHistory } from "./useAttemptHistoryViewModel";

export const AttemptHistory = ({
  open,
  users = [],
  assignmentId,
  currentAttemptId,
  stateManager,
}) => {
  const { attemptList, getAttempts } = useAttemptHistory({ stateManager });
  const { classes } = useStyles();
  const [currentActivity, setCurrentActivity] = useState(null);
  const [issueIndex, setIssueIndex] = useState(0);

  const handleActivityChange = (activity) => {
    setIssueIndex(0);
    setCurrentActivity(activity);
  };

  const handleBack = () => setCurrentActivity(null);

  useEffect(() => {
    if (assignmentId && open) {
      getAttempts({ assignmentId });
    }
  }, [open, assignmentId, currentAttemptId]);

  const renderActivities = () => {
    if (attemptList.length === 0) {
      return (
        <EmptyMessageView
          title="No History"
          subtitle="No attempt history has been collected for this assignment yet."
        />
      );
    }

    return Object.entries(
      groupActivitiesByDate(attemptList, ["statusModifiedOn", "modifiedOn"])
    ).map(([date, activities]) => {
      const timelineData = {
        [date]: groupActivitiesForTimeline(activities, [
          "statusModifiedOn",
          "modifiedOn",
        ]),
      };
      return (
        <ActivityTimeline
          key={date}
          data={timelineData}
          showHeader={false}
          showDate
          disableSpacing
          renderDetail={(activity) => (
            <Box className={classes.attempt}>
              <IssueList
                readOnly
                testId={`issue-list-${activity.id}`}
                attempt={activity}
                highlight={currentAttemptId === activity.id}
                onViewClick={() => handleActivityChange(activity)}
              />
            </Box>
          )}
        />
      );
    });
  };

  return (
    <Box className={classes.container}>
      {currentActivity ? (
        <Closingout
          readOnly
          users={users}
          attempt={currentActivity}
          issueIndex={issueIndex}
          setIssueIndex={setIssueIndex}
          onCancel={handleBack}
        />
      ) : (
        renderActivities()
      )}
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  attempt: {
    padding: theme.spacing(1, 0, 1, 2),
  },
}));
